
// Vue
import {Options, Vue} from "vue-class-component";

// Models
import {AdministratorPlayersProfileDiagnosticsListFormCreate} from "@/models/app/administrator/players/profile/diagnostics/list/form/create";
import {AppCommonDiagnosticCategory} from "@/models/app/common/diagnostic-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElInputNumber,
  ElSelect,
  ElOption,
  ElDatePicker,
  ElTimeSelect,
  ElButton,
} from "element-plus";
import {Plus} from "@element-plus/icons-vue";

// Services
import {postRequest} from "@/services/api/request";

@Options({
  props: [
    "diagnosticCategories",
  ],
  components: {
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElInputNumber,
    ElSelect,
    ElOption,
    ElDatePicker,
    ElTimeSelect,
    ElButton,
    Plus,
  },
})
export default class AdministratorPlayersProfileDiagnosticsListFormCreateIndexVue extends Vue {
  isLoading: boolean | null = false;
  isDialogVisible: boolean | null = false;

  diagnosticCategories: Array<AppCommonDiagnosticCategory> = [];

  formData: AdministratorPlayersProfileDiagnosticsListFormCreate = new AdministratorPlayersProfileDiagnosticsListFormCreate();
  formDataRules = {
    user_id: [
      {
        required: true,
        message: "Polje nije popunjeno",
        trigger: "blur",
      },
    ],
    organization_id: [
      {
        required: true,
        message: "Polje nije popunjeno",
        trigger: "blur",
      },
    ],
    diagnostic_category_id: [
      {
        required: true,
        message: "Polje nije popunjeno",
        trigger: "blur",
      },
    ],
    content: {
      date: [
        {
          required: true,
          message: "Polje nije popunjeno",
          trigger: "blur",
        },
      ],
    },
  };

  diagnosticCategory: AppCommonDiagnosticCategory = new AppCommonDiagnosticCategory();

  $refs!: {
    formComponent: HTMLFormElement;
  };

  validateForm(): void {
    this.$refs.formComponent.validate((response: any) => {
      if (response) {
        this.submitForm();
      }
    });
  }

  setDiagnosticCategory(): void {
    const diagnosticCategory = this.diagnosticCategories.find((item: AppCommonDiagnosticCategory) => {
      return item.id === this.formData.diagnostic_category_id;
    });

    if (diagnosticCategory) {
      this.diagnosticCategory = diagnosticCategory;

      const fields = [];
      this.diagnosticCategory.content.fields.forEach((item: any) => {
        fields.push({
          value: "",
          name: item.name,
          property: item.property,
        })
      });
      this.formData.content.fields = fields;
    }
  }

  async submitForm(): Promise<void> {
    this.isLoading = true;
    await postRequest({
      uri: "/common/diagnostic/create",
      formData: this.formData,
      isProtected: true,
      isSuccessNotificationVisible: true,
      isErrorNotificationVisible: true,
    }).then((r: ResponseIndex) => {
      if (r.status === "success") {
        this.$emit('getDiagnostics');
        this.isDialogVisible = false;
        this.resetFormData();
      }
    });
    this.isLoading = false;
  }

  resetFormData(): void {
    this.formData = new AdministratorPlayersProfileDiagnosticsListFormCreate();
    this.diagnosticCategory = new AppCommonDiagnosticCategory();
  }

  created(): void {
    this.formData.user_id = this.$route.params.id;
  }
}
